import { ADMINISTRATION_KEY } from "./dataMappers";
import { HR_DEPT_ID } from "./hrStaffHelpers";

/** Maps frontend department keys to backend department codes */
export const FRONTEND_DEPT_TO_BACKEND_CODE = {
  "hr-dept": "HR",
  operations: "OPS",
  marketing: "MKT",
  accounts: "ACC",
  warehouse: "WH",
};

export function memberTypeToRoleSlug(memberType, departmentId, viewerRole) {
  if (
    memberType === "department-manager" &&
    departmentId === HR_DEPT_ID &&
    (viewerRole === "gm" || viewerRole === "admin")
  ) {
    return "hr";
  }
  // Anyone placed in the HR department (except the singleton HR head) → hr_staff
  if (departmentId === HR_DEPT_ID && memberType !== "department-manager") {
    return "hr_staff";
  }
  if (memberType === "department-manager") return "department_manager";
  if (memberType === "regional-manager") return "regional_manager";
  if (memberType === "branch-manager") return "branch_manager";
  if (
    memberType === "supervisor" ||
    memberType === "section-manager"
  ) {
    return "manager";
  }
  return "employee";
}

export function resolveBackendDepartmentId(frontendDeptId, departments = []) {
  if (!frontendDeptId) return null;
  const byFrontend = departments.find((d) => d.id === frontendDeptId);
  if (byFrontend?.backendId) return byFrontend.backendId;
  const code = FRONTEND_DEPT_TO_BACKEND_CODE[frontendDeptId];
  if (code) {
    return departments.find((d) => d.code === code)?.backendId ?? null;
  }
  return frontendDeptId;
}

export function mapBackendEmployeeRow(emp) {
  const deptCode = emp.department?.code;
  const frontendDeptId =
    Object.entries(FRONTEND_DEPT_TO_BACKEND_CODE).find(
      ([, code]) => code === deptCode,
    )?.[0] ?? emp.departmentId;

  const roleSlugs = emp.roleSlugs || [];
  const roleSlug = emp.roleSlug;
  let memberLevel = "employee";
  // Hierarchy role wins over job title (title can be e.g. أخصائي تسويق).
  if (roleSlugs.includes("gm") || roleSlug === "gm") {
    memberLevel = "gm";
  } else if (roleSlugs.includes("owner") || roleSlug === "owner") {
    memberLevel = "owner";
  } else if (
    roleSlugs.includes("department_manager") ||
    roleSlugs.includes("hr") ||
    roleSlug === "department_manager" ||
    roleSlug === "hr"
  ) {
    memberLevel = "department-manager";
  } else if (
    roleSlugs.includes("regional_manager") ||
    roleSlug === "regional_manager"
  ) {
    memberLevel = "regional-manager";
  } else if (
    roleSlugs.includes("branch_manager") ||
    roleSlug === "branch_manager"
  ) {
    memberLevel = "branch-manager";
  } else if (emp.jobTitle?.includes("مدير إدارة")) {
    memberLevel = "department-manager";
  } else if (
    emp.jobTitle === "مدير منطقة" ||
    emp.jobTitle?.includes("مدير منطقة")
  ) {
    memberLevel = "regional-manager";
  } else if (emp.jobTitle === "مدير فرع") {
    memberLevel = "branch-manager";
  } else if (
    emp.jobTitle?.includes("مدير قسم") ||
    emp.jobTitle?.includes("رئيس قسم")
  ) {
    memberLevel = "section-manager";
  } else if (emp.jobTitle === "مشرف") {
    memberLevel = "supervisor";
  } else if (
    String(emp.jobTitle || "")
      .replace(/[\s\-_\/]+/g, "")
      .includes("تيمليدر") ||
    String(emp.jobTitle || "")
      .replace(/[\s\-_\/]+/g, "")
      .toLowerCase()
      .includes("teamleader")
  ) {
    const hasFieldBranch =
      emp.branchId && emp.branchId !== ADMINISTRATION_KEY;
    memberLevel = hasFieldBranch ? "supervisor" : "section-manager";
  } else if (roleSlugs.includes("manager") || roleSlug === "manager") {
    if (frontendDeptId !== "operations") {
      memberLevel = "section-manager";
    } else {
      const hasBranch = Boolean(emp.branchId || emp.branch?.id);
      memberLevel = hasBranch ? "supervisor" : "section-manager";
    }
  }

  return {
    id: emp.id,
    name: emp.fullName,
    code: emp.employeeCode,
    email: emp.email,
    jobTitle: emp.jobTitle,
    status:
      emp.status === "ACTIVE"
        ? "active"
        : emp.status === "ON_LEAVE"
          ? "on-leave"
          : emp.status === "TERMINATED"
            ? "terminated"
            : "inactive",
    joinDate: emp.hireDate?.slice?.(0, 10) || emp.hireDate,
    branchId: emp.branchId || emp.branch?.id || ADMINISTRATION_KEY,
    branchBackendId: emp.branchId || null,
    managedBranchIds: emp.managedBranchIds || [],
    departmentId: frontendDeptId,
    memberLevel,
    roleSlugs,
    _fromBackend: true,
  };
}

export function slugifyEmailLocal(name) {
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ".")
    .replace(/[^a-z0-9._-]/g, "");
}
